const data = [

"Against 反对",
"Mildew 霉菌",
"All Natural 全天然",
"Allergens 过敏原",
"Anti 抗",
"Anti-Bacteria 抗菌",
"Antibacterial 抗菌",
"Anti-Bacterial Vinyl 抗菌乙烯基",
"Antibiotic 抗生素",
"Anti-Flu 抗流感",
"Antifouling 防污",
"Anti-Fouling 防污",
"Antifungal 抗真菌",
"Antimicrobial 抗菌",
"Anti-Mildew 防霉",
"Anti-Mites 抗螨",
"Anti-Mold 抗霉",
"Anti-Oxidation 抗氧化",
"Anti-Toxic 抗毒",
"Anti-Virus 抗病毒",
"Bacteria 细菌",
"Bacteriostatic 细菌抑制",
"Bpa-Free 不含BPA",
"Bug 臭虫",
"Chemical 化学",
"Destroy 摧毁",
"Destroying 摧毁",
"Disinfect 消毒",
"Drug 药物",
"Dust 灰尘",
"Dustproof 防尘",
"Eco-Friendly 环保",
"Eliminate 消除",
"Environment Friendly 环保",
"Environmental protection 环保",
"Filter Air 过滤空气",
"Filters 过滤器",
"Fungal 真菌",
"Fungus 真菌",
"Germs 细菌",
"Harmless 无害",
"Healthy 健康",
"Hygience 卫生",
"Hypoallergenic 低过敏性",
"Infection 感染",
"Inhibit-Algae 抑制藻类",
"Insect Prevention 防虫",
"Insect Repellent 驱虫剂",
"Insecticidal 杀虫剂",
"Insecticide 杀虫剂",
"Insects 昆虫",
"Laser 激光",
"Light 光",
"Uv 紫外线",
"Micro-Bio 微生物",
"Mildew 霉菌",
"Mildew Proof 防霉",
"Mites 螨虫",
"Mitigating Any Pest 减轻任何害虫",
"Moisture 湿度",
"Mold 霉菌",
"Mosquitos 蚊子",
"Mouse 老鼠",
"Non-Injurious 无害",
"Non-Poisonous 无毒",
"Nontoxic 无毒",
"Non-Toxic 无毒",
"Odourless 无味",
"Pest 害虫",
"Pesticide 杀虫剂",
"Pests 害虫",
"Preservatives 防腐剂",
"Prevent 预防",
"Prevent Or Inhibit The Growth Of Bacteria 预防或抑制细菌生长",
"Preventing 预防",
"Protect 保护",
"Rat 老鼠",
"Remove 去除",
"Remove Allergens 去除过敏原",
"Repel Insects 驱虫",
"Repel Or Slow Down Any Pest 驱逐或减缓任何害虫",
"Repelient 驱虫剂",
"Repelling 驱逐",
"Repel-Pesticides 驱除杀虫剂",
"Residue 残留物",
"Resist Ultraviolet Rays 抵抗紫外线",
"Resistant 抗",
"Resistant to mosquitoes&ants 抗蚊虫和蚂蚁",
"Rodent 啮齿动物",
"Safety 安全",
"Sanitize-Blight 消毒",
"Sterilization 灭菌",
"Sterilize 灭菌",
"Stop-Microbe 阻止微生物",
"Mildew 霉菌",
"Toxic 有毒",
"Ultraviolet 紫外线",
"Used To Prevent 用于预防",
"Uv 紫外线",
"Virus 病毒",
"Water Filtration 水过滤",
"Explosion 爆炸",
"butane 丁烷",
"bomb 炸弹",
"hydrogen bomb 氢弹",
"missile 导弹",
"Poison 毒药",
"Bane 祸根",
"Ozone 臭氧",
"Asbestos 石棉",
"Fireworks 烟火",
"Firecracker 鞭炮",
"Weapon 武器",
"Gun 枪",
"Bomb 炸弹",
"Torture instrument 刑具",
"Knife 刀",
"Fork 叉",
"Steel pipe 钢管",
"Sword 剑",
"Arrow 箭",
"blade 刀片",
"dagger 匕首",
"Radioactivity 放射性",
"Freon 氟利昂",
"Police 警察",
"Police uniform 警服",
"Military 军事",
"Medal 奖章",
"Institutional emblem 机构徽章",
"India 印度",
"Indian tribe 印第安部落",
"Signal jammer 信号屏蔽器",
"Bank card duplicator 银行卡复制器",
"Signal transmitter 信号发射器",
"Decoder 解码器",
"Virtual currency 虚拟货币",
"Cultural Relic 文物",
"human organ 人体器官",
"Remains 遗骸",
"ivory 象牙",
"gamble 赌博",
"handbookinger 手表",
"cigarette 香烟",
"hookah 水烟",
"cigar 雪茄",
"electronic cigarette 电子烟"


];
export default data;
